import { render, staticRenderFns } from "./FacebookPageInstagramPosts.vue?vue&type=template&id=00cce74e"
import script from "./FacebookPageInstagramPosts.vue?vue&type=script&lang=js"
export * from "./FacebookPageInstagramPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports